unable to read source [project]/frontend/node_modules/src/strings.ts